import { type ReactNode, type Ref } from 'react';
import clsx from 'clsx';

import styles from '../TextInput.module.css';

export function InputContainer({
  children,
  className,
  textInputRef,
}: {
  children: ReactNode;
  className?: string;
  textInputRef?: Ref<HTMLDivElement>;
}) {
  return (
    <div className={clsx(styles.container, className)} ref={textInputRef}>
      {children}
    </div>
  );
}
